import Garments from "../img/Garments.png";
import seasons from "../img/seasons.png";
import special from "../img/special.png";
/* import sustainability from "../img/Sustainability.jpg";
 */ // import sustainability from "../img/sust.jpg";
import sustainability from "../img/sus_1.webp";

export const discoverData = [
  {
    title: "Garments",
    categories: ["Jeans", "Shirts", "T-Shirts", "Coats"],
    img: Garments,
  },
  {
    title: "Sustainability",
    categories: [
      "Mineral dye",
      "H20",
      "All Green EIM Score",
      "Organic cotton (GOTS)",
      "Recycled fibres (GRS)",
      "Natural fibres",
    ],
    img: sustainability,
  },
];
